var map = {
	"./addingdata/1.js": [
		190,
		0
	],
	"./addingdata/2.js": [
		191,
		1
	],
	"./addingdata/3.js": [
		192,
		2
	],
	"./addingdata/4.js": [
		193,
		3
	],
	"./fundamentalassumptions/1.js": [
		194,
		4
	],
	"./fundamentalassumptions/2.js": [
		195,
		5
	],
	"./fundamentalassumptions/3.js": [
		196,
		6
	],
	"./fundamentalassumptions/4.js": [
		197,
		7
	],
	"./fundamentalassumptions/figures/InteractiveFigure.js": [
		198,
		8
	],
	"./fundamentalassumptions/parameters.js": [
		187,
		9
	],
	"./index.js": [
		12
	],
	"./whatisgpr/1.js": [
		199,
		10
	],
	"./whatisgpr/2.js": [
		200,
		11
	],
	"./whatisgpr/3.js": [
		201,
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 754;
module.exports = webpackAsyncContext;